import * as React from 'react'
import { useDispatch } from 'react-redux'
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import { adminResetUserPassword } from '../../../services'
import { setIsStored } from '../../../redux/slices/Alerts'

/**
 * Reseteo de contraseña de usuario a nivel de tabla. Controlado de forma
 * imperativa (`ref.openModal(user)`) para sobrevivir a refetch/re-render del
 * DataGrid.
 */
const ResetPasswordModal = React.forwardRef((_props, ref) => {
  const dispatch = useDispatch()
  const [user, setUser] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  React.useImperativeHandle(ref, () => ({
    openModal: targetUser => {
      if (!targetUser?.id) return
      setUser(targetUser)
      setOpen(true)
    },
  }))

  const handleClose = () => {
    if (loading) return
    setOpen(false)
  }

  const handleConfirm = async () => {
    if (!user) return
    setLoading(true)
    try {
      const result = await adminResetUserPassword(user.id)
      dispatch(
        setIsStored({
          stored: result?.reset !== false,
          message: result?.message || 'Código enviado',
        }),
      )
    } catch {
      dispatch(setIsStored({ stored: false, message: 'Error al enviar el código' }))
    } finally {
      setLoading(false)
      setOpen(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Resetear contraseña</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Se enviará un código temporal al correo <strong>{user?.email}</strong>.
          <br />
          <br />
          El usuario deberá ingresarlo como contraseña y crear una nueva al entrar.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="warning" disabled={loading}>
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Enviar código'}
        </Button>
      </DialogActions>
    </Dialog>
  )
})

ResetPasswordModal.displayName = 'ResetPasswordModal'

export default ResetPasswordModal
